var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"logolayer pt-5 pb-2 mx-auto"},[_c('h1',[_vm._v("Utcakereso.hu")])])
}]

export { render, staticRenderFns }